import { useState, useCallback } from 'react'
import { formatApiError } from '@/utils/httpErrors'

export interface ApiState<T> {
  data: T | null
  loading: boolean
  error: string | null
}

export function useApi<T>() {
  const [state, setState] = useState<ApiState<T>>({
    data: null,
    loading: false,
    error: null,
  })

  const execute = useCallback(async (apiFn: () => Promise<T>): Promise<T | null> => {
    setState({ data: null, loading: true, error: null })
    try {
      const result = await apiFn()
      setState({ data: result, loading: false, error: null })
      return result
    } catch (err: unknown) {
      const message = formatApiError(err)
      setState({ data: null, loading: false, error: message })
      return null
    }
  }, [])

  return { ...state, execute }
}
